export const appSettings = {
  BaseUrl: process.env.VUE_APP_FOYS_TOURNAMENT_API_BASE_URL,
  MyEnvironmentUrl: process.env.VUE_APP_FOYS_MY_ENVIRONMENT_BASE_URL,
  FederationId: process.env.VUE_APP_FEDERATION_ID,
};
